import { FC, ReactNode } from 'react'
import styled from 'styled-components'

type Props = {
  children: ReactNode
}
export const HelperText: FC<Props> = ({ children }) => {
  return <StyledErrorMessage>{children}</StyledErrorMessage>
}
const StyledErrorMessage = styled.p`
  font-size: 12px;
  color: #fb6d6d;
`
